__turbopack_context__.v({
  "baseClass": "EfLS7W_baseClass",
  "skeletonShimmer": "EfLS7W_skeletonShimmer",
});
